import { useLayoutEffect } from 'react'
import { useIfcStore } from '@stores'

/**
 * Colors the IFC GLB model by an explicit guid→color map (hex strings), overriding the default
 * type-based coloring while mounted. The IFC counterpart of `useSceneColoring` for the planar
 * model. `defaultColor` (when set) is applied to any guid not in the map — e.g. grey for elements
 * without a storey assignment. The override is cleared on unmount (or when `enabled` is false).
 */
const useIFCColoring = (
  guidToColor: Record<string, string>,
  defaultColor: string | null = null,
  enabled = true,
): void => {
  const setIfcColorOverride = useIfcStore(state => state.setIfcColorOverride)
  const clearIfcColorOverride = useIfcStore(state => state.clearIfcColorOverride)

  useLayoutEffect(() => {
    if (!enabled) return
    setIfcColorOverride(guidToColor, defaultColor)
    return () => clearIfcColorOverride()
  }, [guidToColor, defaultColor, enabled, setIfcColorOverride, clearIfcColorOverride])
}

export default useIFCColoring
